import { Card, CardContent, Label } from "@altimateai/lego";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@altimateai/lego";
import {
  FieldValues,
  FormState,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { Stack } from "@altimateai/lego";
import ToolFieldItem, { ToolItem } from "./ToolFieldItem";

interface ToolFieldProps {
  registerPrefix?: string;
  register: UseFormRegister<FieldValues>;
  formState: FormState<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  configKey: string;
  configLabel: string;
}

const ToolField = ({
  registerPrefix = "",
  formState,
  watch,
  setValue,
  configKey,
  configLabel,
}: ToolFieldProps) => {
  const fieldKey = `${registerPrefix}${configKey}`;
  const tools: ToolItem[] = watch(fieldKey) || [];

  const handleUpdateTool = (index: number, updatedTool: ToolItem) => {
    const updatedTools = [...tools];
    updatedTools[index] = updatedTool;
    setValue(fieldKey, updatedTools);
  };

  const handleRemoveTool = (index: number) => {
    setValue(
      fieldKey,
      tools.filter((_, i) => i !== index)
    );
  };

  return (
    <Card>
      <CardContent className="al-pt-4">
        <Stack direction="column" className="al-gap-4">
          <Label>
            {configLabel} ({tools.length})
          </Label>
          <Accordion type="multiple" className="al-w-full">
            {tools.map((toolItem, index) => (
              <AccordionItem key={index} value={toolItem.name || String(index)}>
                <AccordionTrigger>{toolItem.name}</AccordionTrigger>
                <AccordionContent>
                  <ToolFieldItem
                    toolItem={toolItem}
                    onChange={(updated: ToolItem) => handleUpdateTool(index, updated)}
                    onRemove={() => handleRemoveTool(index)}
                  />
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          {formState.errors?.[configKey] && (
            <p className="al-text-sm al-text-destructive">
              {formState.errors[configKey]?.message?.toString()}
            </p>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ToolField;
